function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getId as getEventId } from "../../state/event";
import { isFFEnabled } from "../../state/flags";
import { createQueryDefinition, createQueryHook } from "../queryBuilder";
import { keys as keysFn, get as getFn, update as updateFn, oldKeys, oldGet } from "./api";
export var GetConfigKeysQuery = createQueryDefinition(function(isNewConfigUapiEnabled) {
    return [
        "config",
        "keys",
        isNewConfigUapiEnabled
    ];
}, function(param) {
    var _param_queryKey = _slicedToArray(param.queryKey, 3), isNewConfigUapiEnabled = _param_queryKey[2];
    return isNewConfigUapiEnabled ? keysFn() : oldKeys();
});
/*
    1. Example of oldKeys object
    {
      "id": 205,
      "key": "activity_feed_create_post_placeholder",
      "type": "text",
      "default": "Write something... / Text eingeben...",
      "validation": "",
      "precedence": "event",
      "isPurchasable": false,
      "isPurchasableAddon": false,
      "displayName": "Post Placeholder Text for Activity Feed",
      "description": "",
      "price": 0,
      "maxExpiryInDays": null
    }

    2. Example of new keysFn object
    {
      "updatedAt": "2024-06-04T15:46:54.410296+00:00",
      "createdAt": "2024-06-04T15:46:54.410296+00:00",
      "id": "activity_feed_create_post_placeholder",
      "name": "Post Placeholder Text for Activity Feed",
      "parentId": null,
      "description": "",
      "type": "text",
      "maxExpiryInDays": null,
      "default": "Write something... / Text eingeben...",
      "validationSchema": "{'type': 'string', 'default': 'Write something... / Text eingeben...'}"
    }

  // new keysFn returning key name in id is not ideal for the frontend implementation
  // because id should indicate the id of config not the key of it.
  // Hence we are mapping id to key in the select function of useConfigKeysQuery for new API response to make it consistent with old API response and frontend implementation.
  // This will avoid confusion and potential bugs in the future.
*/ export var useConfigKeysQuery = createQueryHook(GetConfigKeysQuery, {
    select: function(param) {
        var data = param.data, meta = param.meta;
        var _meta_request;
        if ((meta === null || meta === void 0 ? void 0 : (_meta_request = meta.request) === null || _meta_request === void 0 ? void 0 : _meta_request.url) === "/cms/v1/configuration_keys") {
            return data;
        }
        return data.map(function(item) {
            return _objectSpreadProps(_objectSpread({}, item), {
                key: item.id
            });
        });
    }
});
export var queryGetConfig = createQueryDefinition(function(eventId, isNewConfigUapiEnabled) {
    return [
        "event",
        String(eventId),
        "config",
        isNewConfigUapiEnabled
    ];
}, function(param) {
    var _param_queryKey = _slicedToArray(param.queryKey, 4), eventId = _param_queryKey[1], isNewConfigUapiEnabled = _param_queryKey[3];
    return isNewConfigUapiEnabled ? getFn(eventId) : oldGet(eventId);
});
/*
    1. Example of oldGet object
    {
        "id": 583522,
        "eventId": 8024,
        "ownerType": "event",
        "ownerId": 0,
        "itemId": 0,
        "keyId": 266,
        "key": "can_people_edit_visibility_preference",
        "value": "0",
        "expiresAt": null
    }

    2. Example of new getFn object
    {
      "value": "1",
      "expiresAt": null,
      "keyId": "is_cms2_event"
    }

    // API is returning key as keyId in the new API. Which is confusing, keys already have their own id field.
    // Hence to avoid confusion we are mapping keyId to key.
*/ export var useConfigQuery = createQueryHook(queryGetConfig, {
    select: function(param) {
        var data = param.data, meta = param.meta;
        var _meta_request, _meta_request_url;
        if (meta === null || meta === void 0 ? void 0 : (_meta_request = meta.request) === null || _meta_request === void 0 ? void 0 : (_meta_request_url = _meta_request.url) === null || _meta_request_url === void 0 ? void 0 : _meta_request_url.includes("/cms/v1/events/")) {
            return data;
        }
        return data.map(function(item) {
            return _objectSpreadProps(_objectSpread({}, item), {
                key: item.keyId
            });
        });
    }
});
export var useConfigUpdateMutation = function() {
    var queryClient = useQueryClient();
    var isNewConfigUapiEnabled = useSelector(function(state) {
        return isFFEnabled(state, "new_config_uapi");
    });
    var eventId = useSelector(getEventId);
    return useMutation({
        mutationFn: function(param) {
            var configs = param.configs;
            return updateFn(eventId, configs.map(function(_param) {
                var key = _param.key, rest = _objectWithoutProperties(_param, [
                    "key"
                ]);
                return _objectSpreadProps(_objectSpread({}, rest), {
                    keyId: key
                });
            }));
        },
        onSuccess: function() {
            queryClient.invalidateQueries({
                queryKey: queryGetConfig.getQueryKey(eventId, isNewConfigUapiEnabled)
            });
        }
    });
};
